// Export types
export type { Feature, FeatureCategory } from './types';

// Import all feature categories
import { resourcesFeatures } from './categories/resources';
import { dashboardFeatures } from './categories/dashboard';
import { homeSafetyFeatures } from './categories/homeSafety';
import { progressFeatures } from './categories/progress';
import { healthMonitoringFeatures } from './categories/healthMonitoring';
import { dailyLivingFeatures } from './categories/dailyLiving';
import { socialNetworkFeatures } from './categories/socialNetwork';
import { activitiesFeatures } from './categories/activities';
import { artsCultureFeatures } from './categories/artsCulture';
import { chatCompanionsFeatures } from './categories/chatCompanions';
import { integrationsFeatures } from './categories/integrations';

// Add-on feature lists (displayed as section headers, not columns)
import { proLevelCareToolsFeatures } from './categories/proLevelCareTools';
import { familyPlusFeatures } from './categories/familyPlus';
import { professionalContextFeatures } from './categories/professionalContext';

// Core feature categories (3-column comparison: Limited Access, ThriveMax, ThriveFamily)
export const featureCategories = [
  dashboardFeatures,
  homeSafetyFeatures,
  progressFeatures,
  healthMonitoringFeatures,
  integrationsFeatures,
  dailyLivingFeatures,
  socialNetworkFeatures,
  activitiesFeatures,
  artsCultureFeatures,
  chatCompanionsFeatures,
  resourcesFeatures
];

// Add-on feature sections (displayed vertically with badges, not as columns)
export const addOnFeatureSections = {
  familyPlus: {
    title: "ThriveFamily+ Enhancements",
    subtitle: "Available as an add-on for families actively coordinating care.",
    badge: "Available with ThriveFamily+",
    features: [
      ...proLevelCareToolsFeatures.features.map(f => f.name),
      ...familyPlusFeatures.features.map(f => f.name)
    ]
  },
  thriveCare: {
    title: "ThriveCare Professional Tools",
    subtitle: "Designed for professional caregivers and care teams.",
    badge: "Available with ThriveCare",
    features: [
      'Care visit documentation',
      'Voice notes',
      'Client reporting summaries',
      'Task tracking',
      'Family communication tools',
      'Compliance-ready documentation',
      ...professionalContextFeatures.features.map(f => f.name)
    ]
  }
};
